import styled from 'styled-components';

export const InputContainer = styled.li`
    .textarea-input > textarea {
        min-height: 10rem;
    }
`;
